const getters = {
  // user data
  token: state => state.user.token,
  name: state => state.user.name,
  
  // app
  page_name: state => state.app.page_name,
  page_name_parent: state => state.app.page_name_parent,
  
  //line
  lineID: state => state.line.lineID,
  avatar: state => state.line.avatar,
  lineName: state => state.line.line_name,
  os: state => state.line.os,
  liffVersion: state => state.line.liffVersion,
}
export default getters
